// export enum DrugTypes {
// 	Synthetic = 1,
// 	Biotech = 2
// };

export enum InteractionType {
  Major = 1,
  Moderate = 2,
  Minor = 3,
  Unknown = 4
}


export enum MedicineLeafletTypes {
  LeafletForUser = 1,
  SmPC = 2,
  EPAR = 3
}


export enum RoaTypeAbbr {
  Implant = 1,
  Inhal = 2,
  Instill = 3,
  N = 4,
  O = 5,
  P = 6,
  R = 7,
  SL = 8,
  TD = 9,
  V = 10
}

export enum RoaTypeDescr {
  Implant = 1,
  Inhalation = 2,
  Instillation = 3,
  Nasal = 4,
  Oral = 5,
  Parenteral = 6,
  Rectal = 7,
  SublingualBuccalOromucosal = 8,
  Transdermal = 9,
  Vaginal = 10
}

export enum AgeGroup {
  Adult = 1,
  Pediatric = 2
}

export enum ProfessionType {
  Driver = 1,
  MachineOperator = 2
}

export enum UnitType {
  g = 1,
  mg = 2,
  mcg = 3,
  U = 4,
  TU = 5,
  MU = 6,
  mmol = 7,
  ml = 8
}

export enum Lang {
  bg = 1,
  en = 2
}

export enum AuthorisationStatus {
  Authorised = 1,
  Withdrawn = 2,
  Refused = 3,
  Pending = 4,
  Suspended = 5
}

export enum RawDataStatus {
  New = 1,
  Imported = 2,
  ImportFailed = 3,
  NewAuthorisationGranted = 4,
  NewAuthorisationSuspended = 5,
  DocumentGenerationFailed = 6
}

export enum EparDocContentConfig {
  Unknown = 0,
  DocCountsEqual = 1,
  SingleDoc = 2,
  FirstAtStartToMissing = 3,
  LastAtEndToMissing = 4,
  StebByStepFromStart = 5
}

export enum DataSourceType {
  EmaEparFile = 1,
  EmaEparText = 2,
  BDAhtml = 3
}

export enum ImportedDataStatus {
  Imported = 1
}

export enum SyncDataStatus {
  NotSynchronized = 1,
  Synchronized = 2,
  SynchronizationFailed = 3,
  SynchronizedBdaHtml = 4,
}

export enum FileSystemType {
  Leaflets = 1,
  LaboratoryResults = 2
}

export enum UserConditionType {
  Height = 1,
  Weight = 2,
  BloodPressure = 3,
  HeartRate = 4,
  Temperature = 5,
  BloodSugar = 6
}

export enum ConditionUnitType {
  First = 1,
  Second = 2
}

export enum GenderType {
  Male = 1,
  Female = 2
}